import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { CLink } from '@coreui/react';

import { getListenerColorIcon } from '../../../../../../../helpers/cms/subscriber';
import { ACCORDION_TYPES, RULE_GROUP, SUBSCRIBER_PATH, VIEW_ALL } from '../../../../../../../constants';

import Headline from '../../../../../../general/Headline';
import CenterSpinner from '../../../../../../general/Loadings/CenterSpinner';

import CreateStepSelectListenerForm from './Step1';
import CreateStepRuleName from './lookup/CreateStep2';
import CreateStepSelectConditionFields from './lookup/CreateStep3';

import { setFlexibleModal, setRuleHaveEditting } from '../../../../../../../actions/common';
import { handleSetAccordion } from '../../../../../../../actions/subscriber';

export const RuleContext = React.createContext({});

const conditionsDefault = [
     [
          {
               conjunction: 'and',
               g0: {
                    type: 'FormCategory',
                    id: '',
                    key: 'Page Location',
                    operator: 'ct',
                    value: '',
                    isRegex: false,
               },
          },
          {
               conjunction: 'and',
               g0: {
                    type: 'FormCategory',
                    id: '',
                    key: 'Match Type',
                    operator: '',
                    value: 'formId',
                    isRegex: false,
               },
          },
          {
               conjunction: '',
               g0: {
                    type: 'FormCategory',
                    id: '',
                    key: 'Match Value',
                    operator: 'ct',
                    value: '',
                    isRegex: false,
               },
          },
     ],
];

const CreateNewFromCrawlRuleSteps = () => {
     return (
          <>
               <CreateStepSelectListenerForm actionType="create" />
               <CreateStepRuleName />
               <CreateStepSelectConditionFields actionType="create" />
          </>
     );
};

const CreateFormCrawlRule = () => {
     const dispatch = useDispatch();
     const history = useHistory();

     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const accountListeners = useSelector((state) => state.subscriber.accountListeners);
     const listenersLoading = useSelector((state) => state.subscriber.loadings.listeners);
     const selectedListenerRule = useSelector((state) => state.subscriber.selectedListenerRule);

     const pathName = history.location.pathname;
     const activeListener = selectedListenerRule !== VIEW_ALL && accountListeners?.find((listener) => listener.id === selectedListenerRule);
     const listenerIconSrc = activeListener ? getListenerColorIcon(activeListener) : '';

     const [activeStep, setActiveStep] = useState(1);
     const [rule, setRule] = useState({
          name: '',
          description: '',
          conditions: conditionsDefault,
          customVariables: [[{ id: '' }]],
          type: 'Lookup Rule',
          group: RULE_GROUP.FORM_CRAWL_RULE,
     });

     const handleClickLink = (accordion) => {
          if (accordion) {
               dispatch(handleSetAccordion({ accordion, pathName }));
          }
          dispatch(setRuleHaveEditting({ show: false, type: '' }));
          dispatch(setFlexibleModal({ show: false, showLv2: false }));
     };

     return (
          <div className="custom-variable-rules rule-detail">
               <Headline title="Create New Form Crawl Rule" iconSrc={listenerIconSrc} alt={activeListener ? activeListener.name + ' icon' : ''}>
                    <p>
                         Use the steps below to configure your form crawl table. Then we will generate the table so you can write the specific form
                         crawl rules to define values for{' '}
                         <CLink
                              className="text-primary"
                              onClick={() => handleClickLink(ACCORDION_TYPES.CUSTOM_VARIABLES)}
                              to={SUBSCRIBER_PATH.CUSTOM_DATA_LAYER_VARIABLES.replace(':secondId', activeAccount.secondId)}
                              as={Link}
                         >
                              Custom Variables
                         </CLink>{' '}
                         in your data layer.
                    </p>
               </Headline>

               {listenersLoading && <CenterSpinner />}

               {!listenersLoading && (
                    <div className="cvr-create-new custom-rule">
                         <RuleContext.Provider value={{ rule, activeStep, setRule, setActiveStep, activeListener }}>
                              <CreateNewFromCrawlRuleSteps />
                         </RuleContext.Provider>
                    </div>
               )}
          </div>
     );
};

export default CreateFormCrawlRule;
